import React, { useState } from "react";
import { IconType } from "react-icons";
import {
  ScreenCardContent,
  ScreenCardHeader,
  ScreenCardWrapper,
} from "./styled";

type Props = {
  tabs: { icon: IconType; label: string; content: React.ReactNode }[];
  primaryColor?: string;
};

const ScreenCard = (props: Props) => {
  const { tabs, primaryColor } = props;
  const [active, setActive] = useState(0);

  return (
    <ScreenCardWrapper>
      <ScreenCardHeader $eyesInnerColor={primaryColor}>
        {tabs.map((tab, idx) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.label}
              onClick={() => {
                setActive(idx);
              }}
              title={tab.label}
              data-active={idx === active}
            >
              <Icon size={40} color={idx === active ? "#fff" : "#666"} />
            </button>
          );
        })}
      </ScreenCardHeader>
      <ScreenCardContent>{tabs[active].content}</ScreenCardContent>
    </ScreenCardWrapper>
  );
};

export default ScreenCard;
